module.exports = __webpack_public_path__ + "static/media/map3.63fea58e.jpg";